import { useRef, useState, useEffect } from "react";
import Select from 'react-select';
import { ddStylesSmall } from "../utils/CommonStyles.js";

let locationOptions = [];
let defaultLocationOptions = [];
let supplierDateOptions = [];
let defaultSupplierDateOptions = [];
const SupplierAppSurveyReadOnlyRow = ({ index, t, partnerSurveyItem, buyerLocations, supplierDates, handleDeleteClick, oddIdx, 
									add, setIsEditMode, isEditMode, setError, handleSubmit, setEditableRecord, rowCount }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const canReadRef = useRef(null);
    const [isCanRead, setIsCanRead] = useState(partnerSurveyItem.canRead);
    const canWriteRef = useRef(null);
    const [isCanWrite, setIsCanWrite] = useState(partnerSurveyItem.canWrite);
    const priorityToBuyerScoreRef = useRef(null);
    const [isPriorityToBuyerScore, setIsPriorityToBuyerScore] = useState(partnerSurveyItem.priorityToBuyerScore);
    const [locationLoaded, setLocationLoaded] = useState(false);
    const [locationsSelected, setLocationsSelected] = useState([]);
    const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);
    
    useEffect(() => {
		 setLocations(buyerLocations);
		 setSupplierDates(supplierDates);
	}, []);
	function setLocations(buyerLocationList) {
        let locationValue = {};
        locationOptions = [];
        defaultLocationOptions = [];
        if (buyerLocationList && buyerLocationList.length > 0) {
            buyerLocationList.map((aBuyerLocation, idx) => {
				locationValue.label = aBuyerLocation.departmentName + " - " + aBuyerLocation.locationName;
                locationValue.value = aBuyerLocation.locationKey;
				 if (partnerSurveyItem.locations && partnerSurveyItem.locations.length > 0) {
            		partnerSurveyItem.locations.map((eachLoc) => {
						if(aBuyerLocation.locationKey == eachLoc.locationKey){
							defaultLocationOptions.push(locationValue);
							return null;
						}
				 	});
				 }
                locationOptions.push(locationValue);
                locationValue = {};
            });
            setLocationLoaded(true);
            setLocationsSelected(defaultLocationOptions);
        }
    }
    const locationHandler = (selectedOptions) => {
        setLocationsSelected(selectedOptions);
    }
	function setSupplierDates(supplierDateList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        defaultSupplierDateOptions = [];
        if (supplierDateList && supplierDateList.length > 0) {
            supplierDateList.map((aSupplierDate, idx) => {
				supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
				 if (partnerSurveyItem.supplierDates && partnerSurveyItem.supplierDates.length > 0) {
            		partnerSurveyItem.supplierDates.map((eachSupplierDate) => {
						if(aSupplierDate.partnershipDateKey == eachSupplierDate.partnershipDateKey){
							defaultSupplierDateOptions.push(supplierDateValue);
							return null;
						}
				 	});
				 }
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
            setSupplierDatesSelected(defaultSupplierDateOptions);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
        setSupplierDatesSelected(selectedOptions);
    }

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, partnerSurveyItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, partnerSurveyItem, submitComplete);
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("canRead_")) {
            setIsCanRead(event.target.checked);
        } else if (name.startsWith("canWrite_")) {
            setIsCanWrite(event.target.checked);
        } else if (name.startsWith("priorityToBuyerScore_")) {
            setIsPriorityToBuyerScore(event.target.checked);
        }  

    }

    function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        if(add){
			setError(t("error.onlyOneOpAllowed"));
		} else {
			setIsSubmit(false);
        	setIsEditMode(true);
        	setLocations(buyerLocations);
        	setSupplierDates(supplierDates);
        	setEditableRecord(rowCount);
		}
    }

    function submitUpdate(event, partnerSurveyItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let updatedValues = {
            partnershipKey: partnerSurveyItem.partnershipKey,
            appSurveyKey: partnerSurveyItem.appSurveyKey,
            canRead: canReadRef.current.checked,
            canWrite: canWriteRef.current.checked,
            priorityToBuyerScore:priorityToBuyerScoreRef.current.checked,
            locationKeys: locationsSelected.map(option => option.value),
            partnershipDateKeys: supplierDatesSelected.map(option => option.value),
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }
    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }
    function submitCancel(event, partnerSurveyItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsCanRead(partnerSurveyItem.canRead);
        setIsCanWrite(partnerSurveyItem.canWrite);
        setIsPriorityToBuyerScore(partnerSurveyItem.priorityToBuyerScore);
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerSurveyItem.surveyDisplayName}</td>
            {isEditMode ? (
                <>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
	                {locationLoaded ? <Select
	                    name="locationKey"
	                    options={locationOptions}
	                    onChange={locationHandler}
	                    placeholder={""}
	                    value={locationsSelected}
	                    isSearchable={true}
	                    isClearable={true}
	                    className="myselect"
	                    inputId="locationKey-input"
	                    isMulti
	                    styles={ddStylesSmall}
	                />
                    : <></>}
                	</td>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
	                {supplierDateLoaded ? <Select
	                    name="supplierDateKey"
	                    options={supplierDateOptions}
	                    onChange={supplierDateHandler}
	                    placeholder={""}
	                    value={supplierDatesSelected}
	                    isSearchable={true}
	                    isClearable={true}
	                    className="myselect"
	                    inputId="supplierDateKey-input"
	                    isMulti
	                    styles={ddStylesSmall}
	                />
                    : <></>}
                	</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canReadRef}
                            name={"canRead_" + partnerSurveyItem.appSurveyKey}
                            id={"canRead_" + partnerSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanRead}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canWriteRef}
                            name={"canWrite_" + partnerSurveyItem.appSurveyKey}
                            id={"canWrite_" + partnerSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanWrite}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
		                <input type="checkbox" className="mycheckbox"
		                    ref={priorityToBuyerScoreRef}
		                    name={"priorityToBuyerScore_" + partnerSurveyItem.appSurveyKey}
		                    id={"priorityToBuyerScore_" + partnerSurveyItem.appSurveyKey}
		                    defaultChecked={true}
		                    checked={isPriorityToBuyerScore}
		                    onChange={onResponseChange}
		                />
		            </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
                </>


            ) : (
                <>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyItem.locationNames}</td>
                	<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyItem.supplierDateString}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyItem.canRead}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyItem.canWrite}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyItem.priorityToBuyerScore}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerSurveyItem.status}</td>
                </>
            )}

            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => submitUpdate(event, partnerSurveyItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
                            onClick={(event) => (submitCancel(event, partnerSurveyItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, partnerSurveyItem)}>
                            {partnerSurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}

            </td>
        </tr>
    )
}
export default SupplierAppSurveyReadOnlyRow;